module.exports = __webpack_public_path__ + "static/img/066_TO8_1630_og.93b4091.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/066_TO8_1630_og.jpg
// module id = Atuc
// module chunks = 0